import { EVENTS_FILTER } from '../../constants/actions';
import { savePreferences } from '../authentication';

export const openFilter = () => ({ type: EVENTS_FILTER.OPEN, field: 'filterOpen' });
export const closeFilter = () => ({ type: EVENTS_FILTER.CLOSE, field: 'filterOpen' });

export const openViewFilter = () => ({ type: EVENTS_FILTER.OPEN, field: 'viewFilterOpen' });
export const closeViewFilter = () => ({ type: EVENTS_FILTER.CLOSE, field: 'viewFilterOpen' });

export const selectPartner = id => {
    return (dispatch, getState) => {
        savePreferences(false, { lastLineupPartner: id })(dispatch, getState);
        dispatch({ type: EVENTS_FILTER.SELECT, selection: id });
    };
};

export const toggleFilter = (collection, identifier) => ({
    type: EVENTS_FILTER.TOGGLE,
    collection: collection,
    key: identifier
});

export const toggleAll = group => ({
    type: EVENTS_FILTER.TOGGLE_ALL,
    group: group
});

export const toggleTimeView = () => ({
    type: EVENTS_FILTER.TOGGLE_ONE,
    field: 'liveView'
});

export const toggleFiltersOpen = () => ({
    type: EVENTS_FILTER.TOGGLE_ONE,
    field: 'filtersOpen'
});

export const toggleActivityOpen = () => ({
    type: EVENTS_FILTER.TOGGLE_ONE,
    field: 'activityOpen'
});

export const toggleListView = () => ({
    type: EVENTS_FILTER.TOGGLE_ONE,
    field: 'listView'
});

export const setFilter = (field, value) => ({
    type: EVENTS_FILTER.SET,
    field,
    value
});



// WEBPACK FOOTER //
// ./src/actions/events/filter.js